// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"CompetitorPrice_sectionWrapper__WsZJq","ifNumberOfPieces":"CompetitorPrice_ifNumberOfPieces__1Lb4f","swTimeRestricted":"CompetitorPrice_swTimeRestricted__DflVH"};